
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Campuses extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/campus/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;

  //clients = ["55964377e4b0d9c8efbf9a43", "5d78a307cf6f02479c878663"];

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.country = "";
    this.city = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.country) this.filterUrl += "&address.country=" + this.country;
    if (this.city) this.filterUrl += "&address.city=" + this.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteCampus(campus) {
    common.setLoading(true);
    try {
      await doGet("/api/campus/" + campus._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
